import { z } from 'zod';

/**
 * Every SPA's Content-Security-Policy refuses `eval`, so Zod's JIT could never
 * run in a browser here. Left on, Zod still probes for it with a caught
 * `new Function("")` the first time an object schema is built, and Chrome
 * reports that probe as a CSP violation on every page. `jitless` skips the
 * probe and gives up nothing the policy had not already taken away. It must run
 * before the first object schema is constructed, so each app's `main.tsx`
 * imports this module first.
 */
z.config({ jitless: true });
